"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.createPatientInfoMachine = void 0;
var _xstate = require("xstate");
var _States = require("../../lib/constants/States");
var _Actions = require("../../lib/constants/Actions");
var _api = require("../../lib/api");
var _covidVaccineUtils = require("../../lib/covidVaccineUtils");
var _utils = require("../../lib/utils");
const actions = {
  setPatientRegistration: (0, _xstate.assign)({
    patientRegistration: (_ctx, ev) => ev.data.patientRegistration
  }),
  sendParentNext: (0, _xstate.sendParent)(ctx => ({
    type: _Actions.NEXT,
    data: {
      patientRegistration: ctx.patientRegistration,
      isCaptchaVerified: ctx.isCaptchaVerified
    }
  })),
  updateFields: (0, _xstate.assign)({
    updatedFields: (_ctx, ev) => ev.data.updatedFields
  }),
  saveFieldsToParent: (0, _xstate.sendParent)(ctx => ({
    type: _Actions.FORM_UPDATE,
    data: {
      updatedFields: ctx.updatedFields
    }
  })),
  setIsCaptchaVerified: (0, _xstate.assign)((_ctx, ev) => ({
    isCaptchaVerified: ev.data
  })),
  setSelectedPatientIndex: (0, _xstate.assign)((_ctx, ev) => ({
    selectedPatientIndex: ev.data.patientIndex
  })),
  setCurrentPatientEhrDemographics: (0, _xstate.assign)({
    ehrPatientList: (ctx, ev) => {
      const updatedPatientList = [...ctx.ehrPatientList];
      updatedPatientList[ctx.selectedPatientIndex].demographics = ev.data;
      return updatedPatientList;
    }
  }),
  handleEhrPatientDemographicLoadFailure: (0, _xstate.assign)(() => ({
    selectedPatientIndex: null
  })),
  blankOutForm: (0, _xstate.assign)(() => ({
    updatedFields: {}
  })),
  setPatientRegFormFromApi: (0, _xstate.assign)((_ctx, ev) => {
    return {
      patientRegForm: ev.data
    };
  }),
  setPatientRegFormFromContext: (0, _xstate.assign)(ctx => {
    const {
      covidVaccinePatientRegFormConfig,
      patientRegFormConfig,
      provider
    } = ctx;
    if ((0, _covidVaccineUtils.isCovidVaccineProvider)(provider) && covidVaccinePatientRegFormConfig) {
      return {
        patientRegForm: covidVaccinePatientRegFormConfig
      };
    } else {
      return {
        patientRegForm: patientRegFormConfig
      };
    }
  })
};
const guards = {
  isCaptchaNotVerifiedCtx: ctx => {
    return !ctx.isCaptchaVerified;
  },
  isCaptchaNotVerifiedSession: (_ctx, ev) => {
    return !ev.data;
  },
  checkIsPatientDemographicAlreadyLoaded: (ctx, ev) => {
    return !!ctx.ehrPatientList[ev.data.patientIndex].demographics;
  },
  checkWasSomebodyElseSelected: (_ctx, ev) => {
    return ev.data.patientIndex === null;
  },
  checkIfEHRAndMainPatientLoaded: ctx => {
    return ctx.ehr && ctx.ehrPatientList && ctx.ehrPatientList.length > 0;
  },
  checkIfEHRWithoutDropdownAndMainPatientLoaded: ctx => {
    return ctx.ehr && !ctx.ehr.show_dropdown && ctx.ehrPatientList && ctx.ehrPatientList.length > 0;
  },
  // needed?
  checkIfEHRButMainPatientDidNotLoad: ctx => {
    return ctx.ehr && (!ctx.ehrPatientList || ctx.ehrPatientList.length == 0);
  },
  receivedValidPatientRegForm: (_ctx, ev) => {
    return (0, _utils.isValidPatientRegForm)(ev.data);
  },
  hasValidPatientRegFormInContext: ctx => {
    return (0, _utils.isValidPatientRegForm)(ctx.patientRegForm);
  }
};
const services = {
  getEhrPatientDemographics: async ctx => {
    const {
      ehrPatientList,
      services
    } = ctx;
    const {
      pid,
      pid_type,
      source_system
    } = ehrPatientList[ctx.selectedPatientIndex].patient_ids[0];
    const api = new _api.Api(ctx.customerCode);
    const demographics = await api.getEhrPatientDemographics(services.getEhrPatientDemographics, {
      pid,
      pid_type,
      source_system
    });
    if (!demographics) {
      throw new Error('Failed to load patient demographics');
    }
    return demographics;
  },
  checkCaptchaVerified: async ctx => {
    const api = new _api.Api(ctx.customerCode);
    const res = await api.checkCaptcha();
    return res.verified;
  },
  fetchPatientRegFormForProvider: async ctx => {
    const {
      services,
      provider
    } = ctx;
    const res = await services.getPatientRegForm(provider.id);
    return res;
  }
};
const machineJSON = _ref => {
  let {
    provider,
    insuranceOptions,
    appointmentQuery,
    selectedAppointment,
    updatedFields,
    covidVaccinePatientRegFormConfig,
    patientRegFormConfig,
    isCaptchaVerified,
    ehr,
    ehrPatientList,
    selectedPatientIndex,
    services,
    customerCode,
    csrfToken
  } = _ref;
  return {
    id: `Machine__${_States.patientInfo}`,
    type: 'parallel',
    context: {
      provider,
      insuranceOptions,
      appointmentQuery,
      selectedAppointment,
      updatedFields,
      covidVaccinePatientRegFormConfig,
      patientRegFormConfig,
      isCaptchaVerified,
      patientRegistration: null,
      ehr,
      ehrPatientList,
      selectedPatientIndex,
      ehrLoadFailure: false,
      services,
      customerCode,
      csrfToken
    },
    states: {
      [_States.ehrData]: {
        initial: _States.routing,
        states: {
          [_States.routing]: {
            always: [{
              cond: 'checkIfEHRButMainPatientDidNotLoad',
              target: _States.ehrMainFailed
            }, {
              cond: 'checkIfEHRWithoutDropdownAndMainPatientLoaded',
              target: _States.ehrFormNoDropdown
            }, {
              cond: 'checkIfEHRAndMainPatientLoaded',
              target: _States.ehrForm
            }, {
              target: _States.freeform
            }]
          },
          [_States.ehrForm]: {
            on: {
              [_Actions.SELECT_PATIENT]: [{
                cond: 'checkWasSomebodyElseSelected',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrSomebodyElseForm
              }, {
                cond: 'checkIsPatientDemographicAlreadyLoaded',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrForm
              }, {
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.pendingEhrPatientDemographics
              }]
            }
          },
          [_States.ehrFormNoDropdown]: {},
          [_States.ehrFormRelatedFailed]: {
            on: {
              [_Actions.SELECT_PATIENT]: [
              // Guaranteed to only have main and 'Someone Else', only one transition available
              {
                cond: 'checkWasSomebodyElseSelected',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrSomebodyElseFormRelatedFailed
              }]
            }
          },
          [_States.ehrSomebodyElseForm]: {
            on: {
              [_Actions.SELECT_PATIENT]: [{
                cond: 'checkWasSomebodyElseSelected',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrSomebodyElseForm
              }, {
                cond: 'checkIsPatientDemographicAlreadyLoaded',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrForm
              }, {
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.pendingEhrPatientDemographics
              }]
            }
          },
          [_States.ehrSomebodyElseFormRelatedFailed]: {
            on: {
              [_Actions.SELECT_PATIENT]: [
              // Guaranteed to only have main and 'Someone Else', only one transition available
              {
                cond: 'checkIsPatientDemographicAlreadyLoaded',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrFormRelatedFailed
              }]
            }
          },
          [_States.ehrMainFailed]: {},
          [_States.ehrSubFailed]: {
            on: {
              [_Actions.SELECT_PATIENT]: [{
                cond: 'checkWasSomebodyElseSelected',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrSomebodyElseForm
              }, {
                cond: 'checkIsPatientDemographicAlreadyLoaded',
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.ehrForm
              }, {
                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                target: _States.pendingEhrPatientDemographics
              }]
            }
          },
          [_States.freeform]: {},
          [_States.pendingEhrPatientDemographics]: {
            invoke: {
              id: 'getEhrPatientDemographics',
              src: 'getEhrPatientDemographics',
              onDone: {
                actions: 'setCurrentPatientEhrDemographics',
                target: _States.ehrForm
              },
              onError: {
                actions: 'handleEhrPatientDemographicLoadFailure',
                target: _States.ehrSubFailed
              }
            }
          }
        }
      },
      [_States.patientForm]: {
        initial: _States.fetchingPatientRegForm,
        states: {
          [_States.fetchingPatientRegForm]: {
            invoke: {
              id: 'fetchPatientRegFormForProvider',
              src: 'fetchPatientRegFormForProvider',
              onDone: [{
                cond: 'receivedValidPatientRegForm',
                actions: 'setPatientRegFormFromApi',
                target: [_States.verifyingPatientRegForm]
              }, {
                actions: 'setPatientRegFormFromContext',
                target: [_States.verifyingPatientRegForm]
              }],
              onError: {
                actions: 'setPatientRegFormFromContext',
                target: [_States.verifyingPatientRegForm]
              }
            }
          },
          [_States.verifyingPatientRegForm]: {
            always: [{
              cond: 'hasValidPatientRegFormInContext',
              target: [_States.dataEntry]
            }, {
              target: [_States.error]
            }]
          },
          [_States.dataEntry]: {
            on: {
              [_Actions.FORM_CHANGE]: {
                actions: ['updateFields', 'saveFieldsToParent']
              },
              [_Actions.SET_PATIENT_REGISTRATION]: [{
                cond: 'isCaptchaNotVerifiedCtx',
                target: _States.checkingCaptchaSession,
                actions: ['setPatientRegistration']
              }, {
                actions: ['setPatientRegistration', 'sendParentNext']
              }]
            }
          },
          [_States.checkingCaptchaSession]: {
            invoke: {
              id: 'checkingCaptchaVerified',
              src: 'checkCaptchaVerified',
              onDone: [{
                cond: 'isCaptchaNotVerifiedSession',
                target: _States.verifyingCaptcha
              }, {
                actions: ['setIsCaptchaVerified', 'sendParentNext']
              }],
              onError: _States.verifyingCaptcha
            }
          },
          [_States.verifyingCaptcha]: {
            on: {
              [_Actions.CAPTCHA_CANCELLED]: {
                target: _States.dataEntry
              },
              [_Actions.CAPTCHA_VERIFIED]: {
                target: _States.dataEntry,
                actions: ['setIsCaptchaVerified', 'sendParentNext']
              },
              [_Actions.CAPTCHA_ERROR]: {
                target: _States.verifyingCaptchaError
              }
            }
          },
          [_States.verifyingCaptchaError]: {
            on: {
              [_Actions.CAPTCHA_RESET]: {
                target: _States.verifyingCaptcha
              },
              [_Actions.CAPTCHA_CANCELLED]: {
                target: _States.dataEntry
              }
            }
          },
          [_States.error]: {}
        }
      }
    }
  };
};
exports.machineJSON = machineJSON;
const makeConfig = () => ({
  actions,
  guards,
  services
});
exports.makeConfig = makeConfig;
const createPatientInfoMachine = _ref2 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref2;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createPatientInfoMachine = createPatientInfoMachine;